import i18n from "i18n";
import styles from "./NotFoundItem.module.scss";
import IconNotFoundItems from "assets/images/icon-not-found-items.png";

export const NotFoundItems = () => {
  return (
    <div className={styles["notFound-container"]}>
      <div className={styles["notFound-table-no-notFound-container"]}>
        <img
          className={styles["notFound-table-no-notFound-icon"]}
          src={IconNotFoundItems}
          alt={i18n.t("no.results.found")}
        />

        <p className={styles["notFound-table-no-notFound-title"]}>
          {i18n.t("no.results.found")}
        </p>
        <p className={styles["notFound-table-no-notFound-subtitle"]}>
          {i18n.t("try.changing.the.applied.filters")}
        </p>
      </div>
    </div>
  );
};
